import {
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React from "react";
// import { useTranslation } from "react-i18next";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import { AdminData } from "../../Constants/Data";
import AppFonts from "../../Constants/AppFonts";

const UsersAdministartion = ({ navigation }) => {
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: AppColors.white,
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TouchableOpacity
            style={{ height: 30, width: 30, justifyContent: "center" }}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15 }}
            />
          </TouchableOpacity>
          <Text
            style={{
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,

              color: AppColors.brown1,
            }}
          >
            {t("common:translation.Administrator")}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={{ width: 16, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Image
            source={AppImages.Plus}
            style={{ width: 18, height: 18, marginLeft: 20 }}
            resizeMode="contain"
          />
        </View>
      </View>

      <View
        style={{ flex: 1, marginTop: 20, backgroundColor: AppColors.white }}
      >
        <View style={{ marginHorizontal: 20 }}>
          <FlatList
            data={AdminData}
            showsVerticalScrollIndicator={false}
            renderItem={({ item }) => (
              <TouchableOpacity
                onPress={() => navigation.navigate("UsersAdministartionView")}
                style={{
                  backgroundColor: AppColors.sandal,
                  width: "100%",
                  marginTop: 20,
                  borderRadius: 12,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingVertical: 10,
                  }}
                >
                  <View style={{ flexDirection: "row" }}>
                    <Image
                      source={item.img1}
                      style={{ width: 73, height: 73, marginLeft: 20 }}
                    />
                    <View
                      style={{
                        flexDirection: "column",
                        marginLeft: 20,
                        marginTop: 10,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                          color: AppColors.brown1,
                          opacity: 0.6,
                        }}
                      >
                        {t("common:translation.Name")}
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassBold,
                          color: AppColors.brown1,
                        }}
                      >
                        {item.H2}
                      </Text>
                    </View>
                  </View>
                  <Image
                    source={item.img2}
                    resizeMode="contain"
                    style={{
                      width: 3,
                      height: 17,
                      marginTop: 10,
                      marginRight: 20,
                      alignItems: "center",
                    }}
                  />
                </View>

                <View
                  style={{
                    width: "100%",

                    borderTopColor: AppColors.brown,
                    borderTopWidth: 0.7,
                    opacity: 0.099,

                    marginBottom: 5,
                  }}
                ></View>
                <View
                  style={{
                    marginHorizontal: 20,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,

                        fontFamily: AppFonts.OverpassMedium,
                        color: AppColors.brown1,
                        width: "60%",
                        opacity: 0.6,
                      }}
                    >
                      {t("common:translation.Email")}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,

                        fontFamily: AppFonts.OverpassMedium,
                        color: AppColors.brown1,
                        width: "50%",
                        opacity: 0.6,
                      }}
                    >
                      {t("common:translation.Contact Number")}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",

                      marginBottom: 20,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,

                        fontFamily: AppFonts.OverpassBold,
                        color: AppColors.brown1,
                        width: "60%",
                      }}
                    >
                      {item.H4}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,

                        fontFamily: AppFonts.OverpassBold,
                        color: AppColors.brown1,
                        width: "50%",
                      }}
                    >
                      {item.H6}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            )}
          ></FlatList>
        </View>
      </View>
    </SafeAreaView>
  );
};

export default UsersAdministartion;

const styles = StyleSheet.create({});
